import { Provider } from "react-redux";
import Home from "./Components/Home";
import store from "./Components/Redux/store";

function App() {
  return (
    <Provider store={store}>
      <div>
        <Home />
      </div>
    </Provider>
  );
}

export default App;
